import { useTranslation } from 'react-i18next';

import { Label, LABEL_TYPE } from '@/components/generic';
import { DeviceDigitalSignage, TickCircle } from '@/resources';
import { getTestId, TestIds } from '@/shared/test-ids';

type ScreenCardProps = {
  name: string;
  deviceName: string;
  onClick?: () => void;
  isSelected?: boolean;
};

export const ScreenCard = ({ name, deviceName, onClick, isSelected }: ScreenCardProps) => {
  const [t] = useTranslation('common');
  return (
    <button
      type='button'
      data-testid={getTestId(TestIds.digitalSignage.screenCard, name)}
      onClick={onClick}
      className={`flex w-full cursor-pointer flex-row items-center rounded-lg border-2 text-left transition-colors duration-200 hover:border-primary-blue ${isSelected ? 'border-secondary-blue-gray bg-primary-gray' : 'border-primary-gray'}`}>
      <div className='h-full p-6'>
        <DeviceDigitalSignage className='h-12 w-8 text-primary-blue' />
      </div>
      <div className='flex size-full flex-row items-center justify-between'>
        <div className='flex flex-col'>
          <Label text={name} type={LABEL_TYPE.H3} className='text-primary-blue' />
          <div className='flex flex-row gap-x-2'>
            <Label
              text={t('device') + ':'}
              type={LABEL_TYPE.PARAGRAPH2}
              className='text-secondary-gray'
            />
            <Label text={deviceName} type={LABEL_TYPE.PARAGRAPH2} className='text-primary-black' />
          </div>
        </div>

        <div
          className={`m-6 flex size-8 items-center justify-center rounded-full border-2 ${isSelected ? 'border-primary-blue bg-primary-blue' : 'border-primary-gray'}`}>
          {isSelected && <TickCircle className='size-5 text-white' />}
        </div>
      </div>
    </button>
  );
};
